import { AsyncType, createAsyncTypes } from "@ctra/utils";

const ns = "app/favourites";

/**
 * Fetch favourites
 * @category Type
 */
const FETCH_FAVOURITES: AsyncType = createAsyncTypes(ns, "FETCH_FAVOURITES");

/**
 * Add a chart to favourites
 */
const ADD_TO_FAVOURITES: AsyncType = createAsyncTypes(ns, "ADD_TO_FAVOURITES");

/**
 * Remove a chart from favourites
 */
const REMOVE_FROM_FAVOURITES: AsyncType = createAsyncTypes(ns, "REMOVE_FROM_FAVOURITES");

export default {
  FETCH_FAVOURITES,
  ADD_TO_FAVOURITES,
  REMOVE_FROM_FAVOURITES
};
